<template>
  <div class="changestate">
    <div class="changgecontent" v-if="timeArr">
      <div class="changetree"></div>
      <div class="row">
        <div class="col-md-3">
          <ul class="changestateul">
            <!--<li " @click="toggle(index, tab.view)">
              第{{ index + 1 }}步：
              <span class="lititle" :class="{ active: active == index }">{{
                tab.type
              }}</span>
              <div class="rightbtn"><button class="btn btn-success">进入选题</button></div>
            </li>-->
            <li v-if="timeArr.startTime">
              <div class="margin-b-20">
                <span class="slot"></span>
                第1步：
                <span
                  class="lititle"
                  :class="{ active: this.$route.name === 'ChangeStateFirst' }"
                >论文选题</span
                >
              </div>
              <div class="treecontent"   :class="{ actives: this.$route.name === 'ChangeStateFirst' }">
                <div class="margin-b-20 detail">
                  <span class="">开题时间：</span
                  ><span class="bgcolor"
                >{{ timeArr.startTime }}-{{ timeArr.endTime }}</span
                >
                </div>
                <router-link
                  to="/graduationManagement/changestatefirst"
                  active-class="active"
                >进入选题
                </router-link>
              </div>
            </li>
            <li v-if="timeArr.guideStart">
              <div class="margin-b-20">
                <span class="slot"></span>
                第2步：
                <span class="lititle" :class="{ active: this.$route.name === 'ChangeStateSecond' }">论文指导</span>
              </div>
              <div class="treecontent" :class="{ actives: this.$route.name === 'ChangeStateSecond' }">
                <div class="margin-b-10 detail">
                  <span class="">指导时间：</span
                  ><span class="bgcolor"
                >{{ timeArr.guideStart }}-{{ timeArr.guideEnd }}</span
                >
                </div>
                <div class="margin-b-20 detail">
                  指导时间：<strong class="bgcolor"
                >论文标题：论怎么教好初中物理</strong
                >
                </div>
                <div class="rightbtn">
                  <router-link
                    to="/graduationManagement/changestatesecond"
                    active-class="active"
                  >查看指导
                  </router-link>
                </div>
              </div>
            </li>
            <li v-if="timeArr.checkStart">
              <div class="margin-b-20">
                <span class="slot"></span>
                第3步：
                <span class="lititle" :class="{ active: this.$route.name === 'ChangeStateThird' }">论文审核</span>
              </div>
              <div class="treecontent" :class="{ actives: this.$route.name === 'ChangeStateThird' }">
                <div class="margin-b-10 detail">
                  <span class="">审核时间：</span
                  ><span class="bgcolor"
                >{{ timeArr.checkStart }}-{{ timeArr.checkEnd }}</span
                >
                </div>
                <div class="margin-b-20 detail">
                  开题时间：<strong class="bgcolor"
                >论文标题：论怎么教好初中物理</strong
                >
                </div>
                <div class="rightbtn">
                  <router-link
                    to="/graduationManagement/changestatethird"
                    active-class="active"
                  >进入选题
                  </router-link
                  >
                </div>
              </div>
            </li>
            <li v-if="timeArr.enterStart">
              <div class="margin-b-20">
                <span class="slot"></span>
                第4步：
                <span class="lititle" :class="{ active: this.$route.name === 'ChangeStateFourth' }">论文定稿</span>
              </div>
              <div class="treecontent" :class="{ actives: this.$route.name === 'ChangeStateFourth' }">
                <div class="margin-b-10 detail">
                  <span class="">定稿时间：</span
                  ><span class="bgcolor"
                >{{ timeArr.enterStart }}-{{ timeArr.enterEnd }}</span
                >
                </div>
                <div class="margin-b-20 detail">
                  定稿时间：<strong class="bgcolor"
                >论文标题：论怎么教好初中物理</strong
                >
                </div>
                <div class="rightbtn">
                  <div class="rightbtn">
                    <router-link
                      to="/graduationManagement/changestatefourth"
                      active-class="active"
                    >论文定稿
                    </router-link
                    >
                  </div>
                </div>
              </div>
            </li>
            <li v-if="timeArr.answerStart">
              <div class="margin-b-20">
                <span class="slot"></span>
                第5步：
                <span class="lititle" :class="{ active: this.$route.name === 'ChangeStateFifth' }">论文答辩</span>
              </div>
              <div class="treecontent" :class="{ actives: this.$route.name === 'ChangeStateFifth' }">
                <div class="margin-b-10 detail">
                  <span class="">答辩时间：</span
                  ><span class="bgcolor"
                >{{ timeArr.answerStart }}-{{ timeArr.answerEnd }}</span
                >
                </div>
                <div class="margin-b-20 detail">
                  答辩时间：<strong class="bgcolor"
                >论文标题：论怎么教好初中物理</strong
                >
                </div>
                <div class="rightbtn">
                  <router-link
                    to="/graduationManagement/changestatefifth"
                    active-class="active"
                  >论文定稿
                  </router-link
                  >
                </div>
              </div>
            </li>
            <div class="clearfix"></div>
          </ul>
        </div>
        <div class="col-md-9">
          <router-view></router-view>
        </div>
      </div>
      <!--:is实现多个组件实现同一个挂载点-->
      <!--<component :is="currentView"></component>-->
    </div>
    <div style="width: 100%; text-align: center; font-size: 24px" v-else>
      <span>暂未安排相关论文</span>
    </div>
    <!-- <a-button type="primary">点击开始聊天</a-button>
    <div class="chat">
      <chat
        ref="chatmain"
        @close="close"
        @sendMessage="sendMessage"
        :spinning="spinning"
        :currentStudent="currentStudent"
      />
    </div>-->
  </div>
</template>

<script>
import ChangeStateFirst from './ChangeStatefirst'
import ChangeStateSecond from './ChangeStateSecond'
import ChangeStateThird from './ChangeStateThird'
import ChangeStateFourth from './ChangeStateFourth'
import ChangeStateFifth from './ChangeStateFifth'
import chat from '../../chat/chat.vue'

export default {
  name: 'ChangeState',
  components: {
    ChangeStateFirst,
    ChangeStateFifth,
    ChangeStateSecond,
    ChangeStateThird,
    ChangeStateFourth,
    chat,
  },
  created () {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    // this.token = JSON.parse(localStorage.getItem("token"));
  },
  data: function () {
    return {
      active: 0,
      currentView: 'ChangeStateFirst',
      tabs: [
        {
          type: '论文选题',
          view: 'ChangeStateFirst',
        },
        {
          type: '论文指导',
          view: 'ChangeStateSecond',
        },
        {
          type: '论文审核',
          view: 'ChangeStateThird',
        },
        {
          type: '论文定稿',
          view: 'ChangeStateFourth',
        },
        {
          type: '论文答辩',
          view: 'ChangeStateFifth',
        },
      ],
      showFlag: true,
      spinning: false,
      // currentStudent: null,
      userInfo: null,
      token: null,
      timeArr: null,
    }
  },
  mounted () {
    // this.currentStudent = {
    //   id: '1314384464799592401',
    //   teacherId: '1318732772106219522',
    //   teacherName: '张康辉',
    //   studentId: '1318455174063579137',
    //   realname: '薛奎丽',
    //   status: '对方不在线',
    // }
    // this.wantGetWebsock()
    this.getThesis()

  },
  methods: {
    getThesis () {
      this.axios.get(`/biz/thesis/time`).then((res) => {
          if (res.success) {
            const {
              startTime,
              endTime,
              guideStart,
              guideEnd,
              checkStart,
              checkEnd,
              enterStart,
              enterEnd,
              answerStart,
              answerEnd,
            } = res.result
            this.timeArr = {
              startTime,
              endTime,
              guideStart,
              guideEnd,
              checkStart,
              checkEnd,
              enterStart,
              enterEnd,
              answerStart,
              answerEnd,
            }
          }
        }
      )
    },
    toggle (i, v) {
      this.active = i
      this.currentView = v
    },
    close () {
      this.showFlag = false
    },
    // wantGetWebsock () {
    //   let timer = setInterval(() => {
    //     if (this.websock) {
    //       clearInterval(timer)
    //     } else {
    //       this.$bus.$emit('wantGetWebsocketObject')
    //     }
    //   }, 1000)
    //   this.$bus.$on('getWebsocketObject', this.getWebsocket)
    //   this.$bus.$on('newMessageWillbeReceive', this.websocketOnmessage)
    //   this.$bus.$on('getStatus', this.changeSatus)
    // },
    // getWebsocket (websock) {
    //   console.log('执行拿到')
    //   console.log(websock)
    //   this.websock = websock
    //   // this.websock.onmessage = this.websocketOnmessage
    //   // this.websocketSend("发送消息")
    // },
    // websocketOnmessage (data, callback) {
    //   console.log('-----聊天列表接收消息-------', data)
    //   if (this.currentStudent.id === data.msgId) {
    //     let msgObj = {
    //       date: data.msgTxtDate,
    //       img: `/static/images/teacher.png`,
    //       mine: false,
    //       name: this.currentStudent.teacherName,
    //       text: {text: data.msgTxt.toString()},
    //     }
    //     this.$refs.chatmain.newMessage(msgObj)
    //     callback({status: true})
    //   } else {
    //     callback({status: false})
    //   }
    // },
    // changeSatus (data) {
    //   console.log('改变状态')
    //   Object.assign(this.tempCurrentStudent, {status: data.hint})
    //   this.currentStudent = this.tempCurrentStudent
    //   // this.currentStudent.status = data.hint
    //   setTimeout(() => {
    //     this.spinning = false
    //   }, 500)
    // },
    // websocketSend (text, callback) {
    //   // 数据发送
    //   try {
    //     const data = JSON.stringify(text)
    //     this.websock.send(data)
    //     callback()
    //   } catch (err) {
    //     console.log('send failed (' + err.code + ')')
    //   }
    // },
    // sendMessage (message) {
    //   console.log(this.userInfo)
    //   this.websocketSend(
    //     {
    //       cmd: 'HeartBeat',
    //     },
    //     () => {
    //       console.log('成功发送')
    //       this.$refs.chatmain.addMessage(message)
    //     }
    //   )
    // },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.changestate {
  background: #fff;
  min-height: 500px;
  margin-bottom: 30px;
  padding: 28px;

  .changetree {
    border-left: 1px solid #d7dad9;
    height: 880px;
    position: absolute;
    top: 30px;
    left: 28px;
    z-index: 100;
  }

  .changgecontent {
    position: relative;
  }

  .changestateul {
    padding: 20px;
    clear: both;
    background: $bgcontent;
  }

  .changestateul li {
    padding: 30px 0;

    .lititle {
      font-weight: bold;
      cursor: pointer;
      text-align: center;

      &.active {
        color: $bgColor;
      }
    }

    i {
      font-size: 30px;
      position: relative;
      color: #c3c3c3;
      top: 8px;
    }
  }
}

.activeno {
  display: none;
}

.bgcolor {
  color: #333;
}

.btn-default {
  background: #e2e4e0;
  color: #b1b8bf;
  border-radius: 30px;
}

.btn-success {
  background: $bgColor;
  border-radius: 30px;
}

.slot {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 9px;
  background: $bgColor;
  margin-right: 10px;
  position: relative;
  top: 5px;
  border: 3px solid #c5e4c7;
  z-index: 1000;
}

.rightbtn {
  a {
    display: inline-block;
    padding: 5px 10px;
    background: #fdfdfd;
    color: #999;
    border-radius: 3px;
  }
}

.treecontent {
  margin-left: 30px;

  &.actives {
    background: $bgColor;
    padding: 20px;
    border-radius: 3px;
    color: #fff;

    .detail {
      color: #fff;
    }

    .bgcolor {
      color: #fff;
    }

    a {
      color: #fff;
      background: #fff;
      color: $bgColor;
      padding: 3px 10px;
      border-radius: 3px;
    }
  }
}

.margin-b-20 {
  margin-bottom: 15px;
}

.btn {
  padding: 3px 10px;
  border: none;
}

.detail {
  line-height: 24px;
  color: #848886;

  .detail_title {
  }
}

.margin-b-10 {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/graduationmanagement/components/ChangeState.vue